<template>
    <div>
        <el-dialog :title="importitle" width="90%" :visible.sync="dialogVisible" @close='hideDialog'>
            <el-form :inline="true" :rules="formRules" :model="importPar" size="mini" style='text-align:left'>
                <el-form-item label="备注" prop="importBatch">
                    <el-input
                        style='width:150px'
                        type="text"
                        placeholder="请输入更新备注"
                        v-model="importPar.importBatch"
                        maxlength="64"
                        show-word-limit
                        >
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-upload
                        :action="uploadUrl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :headers="headers"
                        :before-remove="beforeRemove"
                        :limit="1"
                        :on-exceed="handleExceed"
                        :before-upload="beforeAvatarUpload"
                        :on-success='success'
                        :on-error='upLoadErr'
                        :with-credentials="true"
                        >
                        <el-button size="medium" type="primary">上传</el-button>
                        <div slot="tip" class="el-upload__tip">请将更新后的文件上传</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button
                        icon="el-icon-upload"
                        type="warning"
                        @click="updataExcel"
                    >
                        批量更新
                    </el-button>
                </el-form-item>
            </el-form>
            <perm-table
                :page="page"
                :columns="columns"
                :selectionChange="selectionChange"
                :handleCurrentHandle="handleCurrentHandle"
                :loading="loading"
                size="mini"
                :showEdit='true'
                :editLabel='editLabel'
                :showOperation='true'
                :showMore='true'
                permsEdit='sys:log'
                @findPage="getRecodes"
                @handleShoMore ='handleShoMore'
                @handleEdit='dlFile'>
            </perm-table>
        </el-dialog>
    </div>
</template>
<script>
import PermTable from '@/components/Component/PermTable/Index'
import PermButton from '@/components//Component/PermButton/Index'
import { baseUrl, uploadUrl } from '../../../utils/global'

export default {
    components: {
        PermTable,
        PermButton
    },
    props: {
        importitle: {
            type: String,
            default: '导入'
        },
        importType: {
            type: Number,
            default: 1
        },
        importableId: {
            type: Number,
            default: 1
        },
        isProvince: {
            type: Boolean,
            default: false
        },
        isXkpage: {
            type: Boolean,
            default: false
        },
        isXkExam: {
            type: Boolean,
            default: false
        },
        isTouDang: {
            type: Boolean,
            default: false
        },
        isZhaoLu: {
            type: Boolean,
            default: false
        },
        isProfRemark: {
            type: Boolean,
            default: false
        },
        isProfInfo: {
            type: Boolean,
            default: false
        },
        isOnLineSchool: {
            type: Boolean,
            default: false
        },
        isTxExamType: {
            type: Boolean,
            default: false
        },
        isProfPredict: {
            type: Boolean,
            default: false
        },
        isSchoolPredict: {
            type: Boolean,
            default: false
        },
        isSegment: {
            type: Boolean,
            default: false
        },
        isProvinceBatch: {
            type: Boolean,
            default: false
        },
        isProvinceBatchLine: {
            type: Boolean,
            default: false
        },
        isProvinceScoreLine: {
            type: Boolean,
            default: false
        },
        isJointCate: {
            type: Boolean,
            default: false
        },
        isSchoolRank: {
            type: Boolean,
            default: false
        },
        isProvJoint: {
            type: Boolean,
            default: false
        },
        isProfLevel: {
            type: Boolean,
            default: false
        },
        isProfexam: {
            type: Boolean,
            default: false
        },
        isEnrollformula: {
            type: Boolean,
            default: false
        },
        isSmallscorelimit: {
            type: Boolean,
            default: false
        },
        isSameprof: {
            type: Boolean,
            default: false
        },
        isTranscode: {
            type: Boolean,
            default: false
        },
        isWishPartners: {
            type: Boolean,
            default: false
        },
        isSchTxExamType: {
            type: Boolean,
            default: false
        },
        isAdmissionSchoolType: {
            type: Boolean,
            default: false
        },
        isCollectionSchoolType: {
            type: Boolean,
            default: false
        },
        isProvinceScheduleType: {
            type: Boolean,
            default: false
        },
        isExamScheduleType: {
            type: Boolean,
            default: false
        },
        isBatchScheduleType: {
            type: Boolean,
            default: false
        },
        isExceptions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            page: {},
            columns: [],
            editLabel: '下载',
            loading: true,
            dialogVisible: true,
            importForm: {
                importBatch: ''
            },
            pageRe: {
                current: 1,
                size: 5
            },
            interVal: '',
            headers: {
                'access-token': sessionStorage.getItem('access-token')
            },
            formRules: {
                importBatch: [{ required: true, message: '批次不能为空', trigger: 'blur' }]
            },
            uploadUrl: `${this.global.uploadUrl}/common/file/upload`,
            importPar: {
                tableId: this.importableId,
                importBatch: '',
                filePath: '',
                originName: ''
            },
            progressData: '100%'
        }
    },
    methods: {
        handleExceed() {

        },
        beforeRemove() {

        },
        handleRemove() {

        },
        handlePreview() {

        },
        beforeAvatarUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
            const extension = testmsg === 'xls'
            const extension2 = testmsg === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 200
            if (!extension && !extension2) {
                this.$message({
                    message: '上传文件只能是 xls、xlsx格式!',
                    type: 'warning'
                })
            }
            if (!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 200MB!',
                    type: 'warning'
                })
            }
            return extension || extension2 && isLt2M
        },
        // 上传成功
        success(response, file, fileList) {
            var data = {
                filePath: response.data,
                originName: file.name
            }
            Object.assign(this.importPar, data)
        },
        upLoadErr(err, file, fileList) {
            if (err) {
                this.$message({ message: '导入失败', type: 'error' })
                return
            }
        },
        updataExcel() {
            var callback = (res) => {
                if (!res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.$message({ message: '操作成功', type: 'success' })
            }
            if (!this.importPar.importBatch) {
                this.$message({ message: '请先输入批次', type: 'warning' })
                return
            }
            // if (this.interVal) {
            //     clearInterval(this.interVal)
            //     this.interVal = ''
            // }
            if (this.isProvince) {
                var module = 'Provincetj'
                var method = 'updataProvinceData'
            } else if (this.isXkpage) {
                module = 'Xkinfo'
                method = 'updataXKinfo'
            } else if (this.isXkExam) {
                module = 'Examplaceinfo'
                method = 'updataEPInfo'
            } else if (this.isTouDang) {
                module = 'TDInfo'
                method = 'updataTData'
            } else if (this.isZhaoLu) {
                module = 'ZlInfo'
                method = 'updataZLData'
            } else if (this.isProfRemark) {
                module = 'ProfRemark'
                method = 'updataProfRemark'
            } else if (this.isProfInfo) {
                module = 'ProfInfo'
                method = 'updataProfInfo'
            } else if (this.isOnLineSchool) {
                module = 'Onlinschool'
                method = 'updateOnLineSchool'
            } else if (this.isTxExamType) {
                module = 'TxExamType'
                method = 'updateTxExamType'
            } else if (this.isProfPredict) {
                module = 'ProfPredict'
                method = 'updateProfPredict'
            } else if (this.isSchoolPredict) {
                module = 'SchoolPredict'
                method = 'updateSchoolPredict'
            } else if (this.isSegment) {
                module = 'SegmentTable'
                method = 'updateSegment'
            } else if (this.isProvinceBatch) {
                module = 'ProvinceBatch'
                method = 'updateProvinceBatch'
            } else if (this.isProvinceBatchLine) {
                module = 'ProvinceBatchLine'
                method = 'updateProvinceBatchLine'
            } else if (this.isProvinceScoreLine) {
                module = 'ProvinceScoreLine'
                method = 'updateProvinceScore'
            } else if (this.isJointCate) {
                module = 'prof'
                method = 'updateJointCate'
            } else if (this.isSchoolRank) {
                module = 'SchoolRank'
                method = 'updateSchoolRank'
            } else if (this.isProvJoint) {
                module = 'prof'
                method = 'updateProvJointCategory'
            } else if (this.isProfLevel) {
                module = 'ProfLevel'
                method = 'updateProfLevel'
            } else if (this.isProfexam) {
                module = 'Profexamcategory'
                method = 'updateProfexam'
            } else if (this.isEnrollformula) {
                module = 'Enrollformula'
                method = 'updateEnrollformula'
            } else if (this.isSmallscorelimit) {
                module = 'Smallscorelimit'
                method = 'updateSmallscorelimit'
            } else if (this.isSameprof) {
                module = 'Sameprof'
                method = 'updateSameprof'
            } else if (this.isTranscode) {
                this.$api.code.batchUpdateCode(this.importPar).then((res) => {
                    callback(res)
                })
                return
            } else if (this.isWishPartners) {
                this.$api.partners.batchUpdateWishPartners(this.importPar).then((res) => {
                    callback(res)
                })
                return
            } else if (this.isSchTxExamType) {
                module = 'TxExamType'
                method = 'updateSchTxExamType'
            } else if (this.isAdmissionSchoolType) {
                module = 'SchoolType'
                method = 'updateSchoolType'
            } else if (this.isCollectionSchoolType) {
                module = 'collectionschool'
                method = 'importUpdateSchool'
            } else if (this.isProvinceScheduleType) {
                module = 'schedule'
                method = 'provinceImportUpdate'
            } else if (this.isExamScheduleType) {
                module = 'schedule'
                method = 'examImportUpdate'
            } else if (this.isBatchScheduleType) {
                module = 'schedule'
                method = 'batchImportUpdate'
            } else if (this.isExceptions) {
                module = 'exceptions'
                method = 'batchUpdateExceptions'
            }
            console.log(this.importPar)
            debugger
            console.log(method)
            console.log(module)
            this.$api[module][method](this.importPar).then((res) => {
                callback(res)
            })
        },
        handleShoMore(par) {
            console.log(par)
            if (par.row.status === '处理成功') {
                this.$alert(par.row.status, '详情', {
                    confirmButtonText: '确定'
                })
            } else if (par.row.status === '处理中') {
                this.$alert(par.row.status, '详情', {
                    confirmButtonText: '确定'
                })
            } else {
                const data = { id: par.row.id }
                this.$api.keyWord.getLog(data).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.data, type: 'error' })
                        return
                    }
                    this.$alert(res.data, '详情', {
                        confirmButtonText: '确定'
                    })
                })
            }
        },
        forMat(q, w, row) {
            debugger
            w.renderCell = function(h, params) {
                if (params.row.status === '处理成功') {
                    return h('a', {
                        attrs: {
                            href: params.row.url
                        },
                        style: {
                            'color': '#14aaff'
                        }
                    }, `${params.row.url}`)
                } else {
                    return h('span', {

                    }, params.row.url)
                }
            }
        },
        getProgress(q, w, row) {
            w.renderCell = function(h, params) {
                if (params.row.status == '处理成功') {
                    return h('span', {

                    }, '100%'

                    )
                } else if (params.row.status == '处理中') {
                    // 超过三十分钟的任务，不再请求进度
                    var time = new Date().getTime()
                    if (time - Date.parse(params.row.createTime) > 30 * 60 * 1000) {
                        return
                    }
                    this.$api.base.getProgress({ id: params.row.id }).then(res => {
                        if (res && !res.success) {
                            this.$message({ message: res.message, type: 'error' })
                            return
                        }
                        console.log('res', res)
                        this.progressData = res.data + '%'
                    })
                    return h('span', {

                    }, this.progressData)
                }
            }
        },
        initColumns: function() {
            this.columns = [
                { prop: 'id', label: 'id', minWidth: 40 },
                { prop: 'bizType', label: '操作类型', minWidth: 80 },
                { prop: 'status', label: '状态', minWidth: 50 },
                { prop: 'logUrl', label: '日志地址', minWidth: 160, formatter: this.forMat },
                { prop: 'createTime', label: '更新时间', minWidth: 100 },
                { prop: 'batch', label: '批次', minWidth: 60 },
                { prop: 'progress', label: '更新进度', minWidth: 50, formatter: this.getProgress }
            ]
        },
        hideDialog() {
            this.$emit('closeImport', this.importForm)
        },
        selectionChange() {

        },
        handleCurrentHandle() {

        },
        getRecodes(dt) {
            var param = {
                bizTypeVal: this.importType
            }
            if (dt) {
                Object.assign(param, dt.pageRequest)
                this.pageRe = dt
            }
            param.size = 5
            this.$api.base.getLogList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }

                this.page = res.data
                if (!dt) {
                    this.hisL = res.data
                }
                this.loading = false
                if (!this.interVal) {
                    this.interVal = setInterval(() => {
                        // debugger
                        this.getRecodes(this.pageRe)
                    }, 2000)
                }
            })
        },
        dlFile(data) {
            if (data.row.status !== '处理成功') {
                this.$message({
                    message: data.row.logUrl || data.row.status,
                    type: 'warning'
                })
                return
            }
            const url = data.row.url
            window.open(url.replace('http:', 'https:'))
        }
    },
    beforeDestroy() {
        if (this.interVal) {
            clearInterval(this.interVal)
            this.interVal = ''
        }
    },
    destroyed() {
        clearInterval(this.interVal)
        this.interVal = ''
    },
    mounted() {
        this.initColumns()
        this.getRecodes()
    }
}
</script>
<style scoped>
    .el-button--medium{
        padding: 7px 13px;
        width: 76.3px;
        font-size: 12px;
        border-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Component/batchUpdate/Index.vue